import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _dec, _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import styles from './ConfettiCannon.m.sass';
import withSize from 'react-sizeme';
import { createConfetti } from './confetti';
var ConfettiCannon = (_dec = withSize({
  monitorWidth: true,
  monitorHeight: true
}), _dec(_class = /*#__PURE__*/function (_React$PureComponent) {
  function ConfettiCannon(props) {
    var _this;
    _classCallCheck(this, ConfettiCannon);
    _this = _callSuper(this, ConfettiCannon, [props]);
    _this.pieces = new Map();
    _this.canvasRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(ConfettiCannon, _React$PureComponent);
  return _createClass(ConfettiCannon, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.confetti = createConfetti(this.canvasRef.current);
      this.update(this.props);
      this.confetti.start(this.props.delay);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(nextProps) {
      this.update(nextProps);
    }
  }, {
    key: "update",
    value: function update(props) {
      this.confetti.configure(props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.confetti.stop();
    }
  }, {
    key: "render",
    value: function render() {
      var size = this.props.size;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.root
      }, /*#__PURE__*/React.createElement("canvas", {
        className: styles.canvas,
        width: size.width,
        height: size.height,
        ref: this.canvasRef
      }));
    }
  }]);
}(React.PureComponent)) || _class);
export { ConfettiCannon as default };
//# sourceMappingURL=index.js.map
